/**
 * Splices `snippet` into `value` over the textarea's selection (or at its
 * caret, which a textarea keeps after losing focus). An empty value becomes
 * the snippet.
 */
export function insertAtCursor(
  textarea: HTMLTextAreaElement | null,
  value: string,
  snippet: string,
): { value: string; caret: number } {
  if (!value || !textarea) {
    const next = value ? `${value}${snippet}` : snippet;
    return { value: next, caret: next.length };
  }
  const start = Math.min(textarea.selectionStart, value.length);
  const end = Math.min(textarea.selectionEnd, value.length);
  return {
    value: value.slice(0, start) + snippet + value.slice(end),
    caret: start + snippet.length,
  };
}

/**
 * After React has rendered the new value: focus the textarea, put the caret
 * at `caret`, and grow the auto-sizing textarea to fit its content.
 */
export function focusTextareaAt(
  textarea: HTMLTextAreaElement | null,
  caret: number,
) {
  requestAnimationFrame(() => {
    if (!textarea) return;
    textarea.focus();
    textarea.setSelectionRange(caret, caret);
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  });
}
